import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { NG1_WINDOW } from '@commons/core/core.provider.ajs';
import { IEpticaExctractAttachment } from '@commons/history/history-mail/models/eptica-extract';
import { isDefined } from 'angular';

@Component({
  selector: 'cng-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
})
export class AttachmentComponent {
  @Input() attachments: IEpticaExctractAttachment[] = [];
  @Input() readOnly = false;
  @Input() disableLink = false;
  @Input() canRemoveLink = false;
  @Output() removeLinkCallback: EventEmitter<IEpticaExctractAttachment> = new EventEmitter<IEpticaExctractAttachment>();
  public visibleAttachment = false;

  constructor(@Inject(NG1_WINDOW) public $window: any) {}

  public toggleAttachmentDisplay(): void {
    if (!this.readOnly) {
      this.visibleAttachment = !this.visibleAttachment;
    }
  }

  public hideAttachment(): void {
    if (!this.readOnly) {
      this.visibleAttachment = false;
    }
  }

  public canDownloadAttachment(file: IEpticaExctractAttachment): boolean {
    return !this.readOnly && !this.disableLink && isDefined(file) && isDefined(file.source);
  }

  public removeLink(file: IEpticaExctractAttachment): void {
    this.removeLinkCallback.emit(file);
  }

  public formatSize(attachment: IEpticaExctractAttachment): string {
    let _ret = '';
    if (attachment.file && attachment.file.size) {
      _ret = ` - ${AttachmentComponent.sizeToStr(attachment.file.size)}`;
    }
    return attachment.title + _ret;
  }

  private static sizeToStr(bytes): string {
    if (bytes === 0) {
      return '0.00 o';
    }
    const e = Math.floor(Math.log(bytes) / Math.log(1024));
    // RTFM : 1024 -- > '1 Ko'   , 1024000 --> '1 Mo'
    return `${(bytes / Math.pow(1024, e)).toFixed(2)} ${' KMGTP'.charAt(e)}o`;
  }
}
